module.exports = __webpack_public_path__ + "static/fa-regular-400-59215032a4397507b80e5625dc323de3.ttf";